import { FilterIcon } from '@/assets/icons/filter-icon'
import { Button } from '@/components/ui/button'
import { forwardRef, type PropsWithChildren } from 'react'

export const FilterButton = forwardRef<HTMLButtonElement, PropsWithChildren>(
  ({ children, ...props }, ref) => (
    <Button
      ref={ref}
      variant="light"
      className="font-bold h-10 flex items-center gap-2"
      type="button"
      {...props}
    >
      {children}
      <FilterIcon />
    </Button>
  ),
)

FilterButton.displayName = 'FilterButton'
